module.exports = __webpack_public_path__ + "img/rub.d713903a.svg";